import axios from "axios"

const axiosPrivate = axios.create({
    baseURL: import.meta.env.VITE_FACEBOOK_BASE_URL,
    headers: { "Content-Type": "application/json" },
})

axiosPrivate.interceptors.request.use(
    (config) => {
        const authToken = localStorage.getItem("token")
        if (authToken) {
            config.params = {
                ...config.params,
                access_token: authToken,
         }
     }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

axiosPrivate.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error.response &&
            error.response.data &&
            error.response.data.message === "Invalid or expired token"
        ) {
            // clearToken()
        }
        return Promise.reject(error)
    }
)

export default axiosPrivate
